import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { adminHubForPath, adminHubTabIsActive } from '@/constants/admin-nav';

export function AdminSectionNav() {
    const { pathname } = useLocation();
    const hub = adminHubForPath(pathname);
    if (!hub || hub.tabs.length < 2) return null;

    return (
        <nav
            aria-label="Secciones del módulo"
            className="flex gap-1 p-1 bg-muted/50 rounded-lg w-fit flex-wrap mb-6"
        >
            {hub.tabs.map((tab) => {
                const active = adminHubTabIsActive(pathname, tab.path);
                return (
                    <NavLink
                        key={tab.path}
                        to={tab.path}
                        className={cn(
                            'px-3 py-1.5 rounded-md text-sm font-medium transition-all whitespace-nowrap',
                            active
                                ? 'bg-primary text-primary-foreground shadow-sm'
                                : 'text-muted-foreground hover:text-foreground',
                        )}
                    >
                        {tab.label}
                    </NavLink>
                );
            })}
        </nav>
    );
}
